import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShareSquareFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12 4L15.5777 7.54815L14.2888 8.82642L12.9114 7.46041V14.4898H11.0886V7.46041L9.71127 8.82642L8.42236 7.54815L12 4ZM10 9.95007H6.17725V20H17.8228V9.95007H14V11.7578H16V18.1923H8.00003V11.7578H10V9.95007Z"
      />
    </SvgIcon>
  );
});
